import { useParams } from 'react-router-dom';
import { useShellTitle } from '../components/layout/ShellTitleContext';
import { SurveyRunner } from '../features/surveys';

// /surveys/:key — BP 24. A single survey instrument, rendered from its JSON
// question set. All the logic (gating, validation, submit) lives in
// SurveyRunner; this page is just the route + title.
export default function SurveyPage() {
  const { key } = useParams<{ key: string }>();
  useShellTitle('Survey');

  if (!key) return null;

  return (
    <div className="ws-page">
      <SurveyRunner instrumentKey={key} />
    </div>
  );
}
